import { MastraClient } from '@mastra/client-js';

// All Mastra traffic routes through web_api_server (v4). The browser must
// never hit the Mastra port directly — the Vite dev proxy and production
// ingress both forward `/mastra/*` to web_api_server, which proxies to the
// Mastra service with session auth enforced. Do not set VITE_MASTRA_URL to
// a Mastra host; if it's set at all it should point at an origin that
// itself proxies `/mastra` through web_api_server.
const MASTRA_URL = import.meta.env.VITE_MASTRA_URL || `${window.location.origin}/mastra`;

export const mastraClient = new MastraClient({ baseUrl: MASTRA_URL });
